module.exports = __webpack_public_path__ + "img/tp-columns-config.bb8750c7.svg";